import { render, staticRenderFns } from "./MdtAttachmentUpload.vue?vue&type=template&id=a138824c&scoped=true"
import script from "./MdtAttachmentUpload.vue?vue&type=script&lang=js"
export * from "./MdtAttachmentUpload.vue?vue&type=script&lang=js"
import style0 from "./MdtAttachmentUpload.vue?vue&type=style&index=0&id=a138824c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a138824c",
  null
  
)

export default component.exports